import {Component, OnDestroy, ViewEncapsulation} from "@angular/core";
import {RouterOutlet} from "@angular/router";
import {DavesaLoadingBarComponent} from "@davesa/components/loading-bar";
import {Subject} from "rxjs";
import {DavesaAlertBannerComponent} from "@davesa/components/alert-banner";

@Component({
    selector: "empty-layout",
    templateUrl: "./empty.component.html",
    encapsulation: ViewEncapsulation.None,
    imports: [DavesaLoadingBarComponent, RouterOutlet, DavesaAlertBannerComponent]
})
export class EmptyLayoutComponent implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
